import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["month", "title", "prevBtn", "nextBtn"]

  connect() {
    this.currentIndex = 0
    this.showCurrentMonth()
  }

  next() {
    if (this.currentIndex < this.monthTargets.length - 1) {
      this.currentIndex++
      this.showCurrentMonth()
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--
      this.showCurrentMonth()
    }
  }

  showCurrentMonth() {
    this.monthTargets.forEach((element, index) => {
      if (index === this.currentIndex) {
        element.classList.remove("hidden")
        
        const monthLabel = element.getAttribute("data-month-label")
        if (this.hasTitleTarget && monthLabel) {
          this.titleTarget.textContent = monthLabel
        }
      } else {
        element.classList.add("hidden")
      }
    })
    
    this.updateButtonStates()
  }

  updateButtonStates() {
    if (!this.hasPrevBtnTarget || !this.hasNextBtnTarget) return
    const isFirstMonth = this.currentIndex === 0
    const isLastMonth = this.currentIndex === this.monthTargets.length - 1
    this.prevBtnTarget.disabled = isFirstMonth
    this.nextBtnTarget.disabled = isLastMonth
    if (isFirstMonth) {
      this.prevBtnTarget.classList.add("opacity-40", "cursor-not-allowed")
    } else {
      this.prevBtnTarget.classList.remove("opacity-40", "cursor-not-allowed")
    }

    if (isLastMonth) {
      this.nextBtnTarget.classList.add("opacity-40", "cursor-not-allowed")
    } else {
      this.nextBtnTarget.classList.remove("opacity-40", "cursor-not-allowed")
    }
  }
}
